
<template>
    
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		</div>
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索 姓名｜郵箱" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
			

				<!-- 高級搜索 1-->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="姓名" class="mb-0">
							<el-input size="small" v-model="from.name" placeholder="搜索姓名"></el-input>
						</el-form-item>
						
						<el-form-item label="郵箱" class="mb-0">
							<el-input size="small" v-model="from.email" placeholder="搜索郵箱"></el-input>
						</el-form-item>

                        <el-form-item label="狀態" class="mb-0">
							<el-select v-model="from.status" size="small" placeholder="請選擇查看類型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="啟用" :value="1"></el-option>
								<el-option label="禁用" :value="0"></el-option>
							</el-select>
						</el-form-item>


						<el-form-item label="申請時間" size="small" class="mb-0">
							<el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
							 range-separator="至" start-placeholder="開始日期" end-placeholder="結束日期" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>


						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜索 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>

					</el-form>
				</template>
			</button-search>
		</div>
        

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="45" align="center">
				</el-table-column>

                <el-table-column type="expand" label="詳情"  width="80">
                    <template slot-scope="props">
                        <el-form inline class="demo-table-expand">
                            <el-form-item label="暱稱">
                                <span>{{ props.row.username }}</span>
                            </el-form-item>
                            <el-form-item label="生日">
                                <span>{{ props.row.birthday }}</span>
                            </el-form-item>
                            <el-form-item label="學校名稱">
                                <span>{{ props.row.school_name }}</span>
                            </el-form-item>
                            <el-form-item label="郵箱">
                                <span>{{ props.row.email }}</span>
                            </el-form-item>
                            <el-form-item label="等級">
                                <span>{{ props.row.level }}</span>
                            </el-form-item>
                            <el-form-item label="聯絡地址">
                                <span>{{ props.row.address }}</span>
                            </el-form-item>
                            <el-form-item label="聯絡電話">
                                <span>{{ props.row.phone }}</span>
                            </el-form-item>
                        </el-form>
                    </template>
                </el-table-column>

				<el-table-column align="center" width="80" prop="user_no" label="ID">
				</el-table-column>
                	
				<el-table-column align="center" prop="grade_name" label="年級">
				</el-table-column>
                
				<el-table-column align="center" prop="name" label="姓名">
				</el-table-column>
				
				<el-table-column align="center" prop="name_en" label="英文姓名">
				</el-table-column>
				
				<el-table-column align="center" prop="class_id" label="班別">
				</el-table-column>

				<el-table-column align="center" prop="number" label="學號">
				</el-table-column>


                <el-table-column align="center" prop="status" label="登錄狀態" >
					<template slot-scope="scope">
						<el-button
						:type="scope.row.status ? 'success' : 'danger'" 
						size="mini"
						
						@click="changeUserStatus(scope.row)"
						plain>{{scope.row.status ? '啟用' : '禁用'}}
						</el-button>
					</template>
				</el-table-column>
				
				<el-table-column align="center" prop="create_time" width="200" label="申請時間">
				</el-table-column>
				
                <el-table-column prop="id" :fixed="this.layout.is_phone?false:'right'" align="center" width="240" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							<el-button @click="audit(scope.row)"  v-auth="'delRule'" size="mini" plain type="success">驗證</el-button>
							<el-button @click="openModel(scope.row)"  v-auth="'delRule'" size="mini" plain type="primary">修改信息</el-button>
						</el-button-group>
					</template>
				</el-table-column>

			</el-table>
		</div>

        <el-dialog
            :visible.sync="dialogVisible"
            title="驗證操作"
            width="30%"
            @close="handleClose"
            >
            <el-form ref="formEdit" :model="currentRow" :label-width="layout.is_phone?'80px':'100px'" :label-position="layout.is_phone?'top':'left'">
				
              <el-form-item label="姓名" prop="title">
					<el-input type="text" disabled v-model="currentRow.name" 
					placeholder="姓名" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>

                <el-form-item label="班別" prop="title">
					<el-input type="text" disabled v-model="currentRow.class_id" 
					placeholder="班別" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>

                <el-form-item label="學號" prop="title">
					<el-input type="text" disabled v-model="currentRow.number" 
					placeholder="學號" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>

            </el-form>
            <span style="color: #F56C6C;">請確認該學生資料是否有誤！ ！</span>

            <div slot="footer" class="dialog-footer">
                <el-button @click="rejectVerification">拒絕</el-button>
                <el-button type="primary" @click="approveVerification">通過</el-button>
            </div>
        </el-dialog>

		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>

		<el-dialog  :close-on-click-modal="false" title="修改密碼" :visible.sync="createModel" 
		top="5vh" :width="layout.is_phone?'90%':'50%'">
			<!-- 表單内容 -->
			<el-form ref="formEdit" :model="form" :label-width="layout.is_phone?'80px':'100px'" :label-position="layout.is_phone?'top':'left'">
				
				<el-form-item label="姓名" prop="name">
					<el-input type="text"  v-model="form.name" 
					placeholder="姓名" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				<el-form-item label="姓名(英文)" prop="name_en">
					<el-input type="text"  v-model="form.name_en" 
					placeholder="姓名(英文)" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>

				<el-form-item label="暱稱" prop="username">
					<el-input type="text"  v-model="form.username" 
					placeholder="暱稱" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>

				<el-form-item label="年級"  prop="grade_id">
					<el-select  v-model="form.grade_id">
						<el-option
						v-for="item in grade_list"
						:key="item.id"
						:label="item.name"
						:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>

                <el-form-item label="班別" prop="class_id">
					<el-input type="text"  v-model="form.class_id" 
					placeholder="班別" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>

                <el-form-item label="學號" prop="number">
					<el-input type="text"  v-model="form.number" 
					placeholder="學號" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				
				<el-form-item label="郵箱" prop="email">
					<el-input type="text"  v-model="form.email" 
					placeholder="郵箱" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
                <el-form-item label="密碼" prop="pass">
					<el-input type="text"  v-model="form.pass" 
					placeholder="不輸入則不修改密碼" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
              
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">確 定</el-button>
			</div>
		</el-dialog>

		<!-- 用戶禁用彈窗 -->
		<el-dialog
			title="禁用用戶"
			:visible.sync="statusDialog.visible"
			width="500px"
			:close-on-click-modal="false"
			@close="closeStatusDialog"
		>
			<el-form :model="statusForm" :rules="statusRules" ref="statusForm" label-width="100px">
				<el-form-item label="用戶資訊">
					<div class="user-info">
						<p><strong>用戶ID:</strong> {{ statusForm.user_id }}</p>
						<p><strong>用戶名:</strong> {{ statusForm.name }}</p>
						<p><strong>當前狀態:</strong> 
							<el-tag :type="statusForm.current_status ? 'success' : 'danger'">
								{{ statusForm.current_status ? '啟用' : '禁用' }}
							</el-tag>
						</p>
					</div>
				</el-form-item>
				
				<el-form-item 
					label="禁用原因" 
					prop="reason" 
					:rules="[{ required: true, message: '禁用用戶時必須提供原因', trigger: 'blur' }]"
				>
					<el-input
						v-model="statusForm.reason"
						type="textarea"
						:rows="4"
						placeholder="請輸入禁用用戶的原因..."
						maxlength="500"
						show-word-limit
					></el-input>
				</el-form-item>
			</el-form>
			
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeStatusDialog">取消</el-button>
				<el-button type="primary" @click="confirmStatusChange" :loading="statusDialog.loading">
					禁用
				</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<style>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  
  .user-info {
    background-color: #f5f7fa;
    padding: 15px;
    border-radius: 4px;
    border: 1px solid #e4e7ed;
  }

  .user-info p {
    margin: 5px 0;
    color: #606266;
  }

  .dialog-footer {
    text-align: right;
  }
</style>
<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					name: '',
					email: '',
					
					status: -1,
					time: [],
				},
				model_title: 'Notice',
				auth_val: 'Notice',
				preUrl: "data/UserAuditList", //列表地址
                addUrl: "data/updateUserAudit", //修改密碼
				delAllUrl: "data/delUserAll", //批量删除地址
				delUrl: "data/delUser", //删除單条地址
                editStatusUrl: "data/editStatusUser", //修改狀態地址

				tableData: [],
				form: {
					id: 0,
					name:"",
					name_en:"",
					username:"",
					grade_id:"",
					class_id:"",
					number:"",
					email:"",
					sex:"",
					pass:"",
				},
				prop: 'create_time',
				sort: 'descending',
				rule_list: [],
				total_list: [],
				check_img_list: [],
				fileList: [],

				school_list: [],
				inst_list: [],
				grade_list: [],
				user_list: [],

                dialogVisible: false,  // 控制弹框的顯示
                currentRow: {

                },       // 存储當前操作的數据行
				
				// 用戶狀態修改彈窗
				statusDialog: {
					visible: false,
					loading: false
				},
				statusForm: {
					user_id: 0,
					name: '',
					current_status: 1,
					reason: ''
				},
				statusRules: {
					reason: [
						{ required: true, message: '禁用用戶時必須提供原因', trigger: 'blur' }
					]
				},
			}
		},
		watch: {
			refreshTrigger(newVal) {
				console.log('刷新触发，當前值:', newVal);
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			this.commonList(['grade_list']);
		},
		methods: {
			handleClick(tab, event) {
				this.search = ''
				this.clearSearch()
				this.getList()
			},
			sortChange(column) {
				this.prop = column.prop
				this.sort = column.order
				this.getList()
			},
            // 關閉弹框
            handleClose() {
                this.dialogVisible = false;  // 隐藏弹框
            },
			//提交
			submit() {
				this.$refs.formEdit.validate(res => {
					if (res) {
					
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},
			//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.grade_list = list.grade
					if (this.grade_list.length > 0) {
						// 设置默認选中项为subject_list中的第一个元素
						this.form.grade_id = this.grade_list[0].id;
					}
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			// 打开验证弹框
            audit(row) {
                this.currentRow = row;
                this.dialogVisible = true; // 顯示弹框
            },
		
			handleAvatarSuccess(res, file) {
				this.form.img = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.head = res.encryption.data.list.url
				}
			},
			
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 2;
				return isJPG && isLt2M;
			},
			
			// 打开模态框
			openModel(e, type) {
				// 修改
				if(e){
					this.form = {
						id:  e.id,
						name: e.name,
						name_en:e.name_en,
						username:e.username,
						grade_id:e.grade_id,
						class_id:e.class_id,
						number:e.number,
						email:e.email,
						sex:e.sex,
						pass:'',
					}
					this.editIndex = e.id
				}else{
					this.form = {
						id: 0,
						name:"",
						name_en:"",
						username:"",
						grade_id:"",
						class_id:"",
						number:"",
						email:"",
						sex:"",
						pass:"",
					}
					this.editIndex = -1
				}
				
				// 打开dialog
				this.createModel = true
			},

            // 拒绝验证操作
            rejectVerification() {
                this.$prompt('請輸入拒絕原因', '提示', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    inputPlaceholder: '請輸入拒絕原因',
                    inputValidator: (value) => {
                        if (!value) {
                            return '拒絕原因不能為空';
                        }
                        return true;
                    },
                    inputErrorMessage: '拒絕原因不能為空',
                }).then(({ value }) => {
                    // 用戶填写了拒绝原因并點擊確認
                    this.processVerification(this.currentRow, 'rejected', value);  // 傳递拒绝原因
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消操作'
                    });
                });
            },

            // 通过验证操作
            approveVerification() {
				this.processVerification(this.currentRow, 'approved');  // 执行通过操作
            },

            // 處理验证操作
            processVerification(row, status, reason = '') {
                // 發送請求或處理數据，`status` 可能是 'approved' 或 'rejected'
                if (status === 'rejected') {
                    console.log('拒絕原因:', reason);
                }

				this.layout.loading = true;
				this.axios.post('/admin/user/UserSchoolAuditStatus', {id:row.id,status:status === 'approved' ? 1 : 2,content:reason}, {
					token: true,
				}).then(res => {
					this.$message({
							message:'操作成功',
							type: 'success'
						});
					this.getList()
					this.layout.getPageNum();
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})

                // 隐藏弹框
                this.dialogVisible = false;
            },
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.total_list = e.total_list
				this.check_img_list = e.list.map(item => {
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					email: '',
				
					status: -1,
					time: [],
				}

				this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			},
			
			// 用戶狀態修改
			changeUserStatus(row) {
				const newStatus = row.status === 1 ? 0 : 1;
				
				// 如果是啟用操作，直接調用API
				if (newStatus === 1) {
					this.directEnableUser(row);
					return;
				}
				
				// 如果是禁用操作，顯示彈窗
				this.statusForm = {
					user_id: row.id,
					name: row.name,
					current_status: row.status,
					reason: ''
				};
				this.statusDialog = {
					visible: true,
					loading: false
				};
				
				// 清空表單驗證
				this.$nextTick(() => {
					if (this.$refs.statusForm) {
						this.$refs.statusForm.clearValidate();
					}
				});
			},
			
			// 直接啟用用戶
			directEnableUser(row) {
				this.$confirm('確認啟用該用戶嗎？', '提示', {
					confirmButtonText: '確定',
					cancelButtonText: '取消',
					type: 'info'
				}).then(() => {
					this.axios.post('/admin/data/editStatusUser', {
						id: row.id,
						status: 1,
						reason: ''
					}, {
						token: true
					}).then(res => {
						if (res.data.code === 1) {
							// 更新本地數據
							row.status = 1;
							this.$message({
								message: '啟用成功',
								type: 'success'
							});
							// 刷新列表
							this.getList();
						} else {
							this.$message.error(res.data.msg || '操作失敗');
						}
					}).catch(err => {
						this.$message.error('操作失敗，請稍後重試');
					});
				}).catch(() => {
					// 用戶取消操作
				});
			},
			
			// 關閉狀態彈窗
			closeStatusDialog() {
				this.statusDialog.visible = false;
				this.statusForm = {
					user_id: 0,
					name: '',
					current_status: 1,
					reason: ''
				};
			},
			
			// 確認狀態修改
			confirmStatusChange() {
				this.$refs.statusForm.validate((valid) => {
					if (valid) {
						this.statusDialog.loading = true;
						
						// 調用API修改狀態
						this.axios.post('/admin/data/editStatusUser', {
							id: this.statusForm.user_id,
							status: 0,
							reason: this.statusForm.reason
						}, {
							token: true
						}).then(res => {
							if (res.data.code === 1) {
								// 更新本地數據
								const user = this.tableData.find(item => item.id === this.statusForm.user_id);
								if (user) {
									user.status = 0;
								}
								
								this.$message({
									message: '禁用成功',
									type: 'success'
								});
								
								// 刷新列表
								this.getList();
							} else {
								this.$message.error(res.data.msg || '操作失敗');
							}
							this.closeStatusDialog();
						}).catch(err => {
							this.$message.error('操作失敗，請稍後重試');
							this.closeStatusDialog();
						}).finally(() => {
							this.statusDialog.loading = false;
						});
					}
				});
			}
		}
	}
</script>

<style>
</style>
